import React from 'react';

interface Props {
  currentStep: number;
  totalSteps: number;
  icons: React.ReactNode[];
}

function ProgressBar({ currentStep, totalSteps, icons }: Props) {
  return (
    <div className="relative">
      <div className="overflow-hidden h-2 mb-6 text-xs flex rounded-full bg-white/20">
        <div
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
          className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-gradient-glass transition-all duration-500"
        ></div>
      </div>
      <div className="flex justify-between">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={`flex items-center justify-center w-12 h-12 rounded-full transition-all duration-500 ${
              index + 1 <= currentStep
                ? 'backdrop-blur-sm bg-gradient-glass border border-white/40 text-gray-800 shadow-lg'
                : 'bg-white/10 text-gray-500'
            }`}
          >
            {icons[index]}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProgressBar;